import { type FC, useState } from 'react';
import { useSelector } from 'react-redux';
import type { TabsProps } from 'antd';

import Tab from '../../../../components/Tabs/Tab';
import LADClaimsDetailsTab from './Details/LADClaimsDetailsTab';
import LADClaimsFilesTab from './Files/LADClaimsFilesTab';
import LADClaimFinancialsTab from './Financials/LADClaimFinancialsTab';
import LADClaimsItemsTab from './Items/LADClaimsItemsTab';
import LADClaimsNotesTab from './Notes/LADClaimsNotesTab';
import LADSettlementsTab from './Settlements/LADSettlementsTab';

const LADEditTabs: FC = () => {
  const [activeEditTab, setActiveEditTab] = useState<TabsProps['activeKey']>('1');
  const selectedClaimKey = useSelector((state: any) => state.lossAndDamage.selectedClaimKey);

  const handleTabChange: TabsProps['onChange'] = (val) => {
    setActiveEditTab(val);
  };

  return (
    <Tab
      onChange={handleTabChange}
      contents={[
        {
          content: <LADClaimsDetailsTab claimKey={selectedClaimKey} />,
          contentKey: '1',
          title: 'Details',
        },
        {
          content: <LADClaimsItemsTab claimKey={selectedClaimKey} />,
          contentKey: '2',
          title: 'Claim Items',
        },
        {
          content: <LADClaimFinancialsTab claimKey={selectedClaimKey} />,
          contentKey: '3',
          title: 'Claim Financials',
        },
        {
          content: <LADClaimsNotesTab claimKey={selectedClaimKey} />,
          contentKey: '4',
          title: 'Claim Notes',
        },
        {
          content: <LADClaimsFilesTab claimKey={selectedClaimKey} />,
          contentKey: '5',
          title: 'Upload/View Files',
        },
        {
          content: <LADSettlementsTab claimKey={selectedClaimKey} />,
          contentKey: '6',
          title: 'Claim Settlements',
        },
      ]}
      defaultActiveKey="1"
      activeKey={activeEditTab}
    />
  );
};

export default LADEditTabs;
